var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXboxOneAButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 17,
    stroke: "#BBBBBB",
    strokeWidth: 2.19355
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.059 29L18.9865 10.9613H21.5582L28.941 29H26.2217L24.1176 23.5367H16.5748L14.5938 29H12.059ZM17.2639 21.5926H23.3793L21.4967 16.5969C20.9225 15.0793 20.4959 13.8324 20.217 12.8562C19.9873 14.0129 19.6633 15.1613 19.2449 16.3016L17.2639 21.5926Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXboxOneAButton);
export default __webpack_public_path__ + "static/media/XBOXOne-AButton.7217e7245e97313e5e57a3a2d12817e6.svg";
export { ForwardRef as ReactComponent };